import React from 'react';
import { useDeviceMonitoring } from '../hooks/useDeviceMonitoring';

const DeviceMonitoringProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useDeviceMonitoring();
  
  return <>{children}</>;
};

export default DeviceMonitoringProvider;

